import { useState } from 'react';
import logo from './images/logo.png';
import { FaFacebook } from 'react-icons/fa';
import Layout from './Layout';
import LegalMentions from './LegalMentions';
import { Slide } from 'react-awesome-reveal';

export const Footer = (props) => {

    const { gotoSection, handleOpenFb, isMobile } = props;

    const [lmOpened, setLmOpened] = useState(false);
    const [ctcOpened, setCtcOpened] = useState(false);

    console.log('lmOpened ?', lmOpened);

    function handleOpenLegalMentions() {
        setLmOpened(true);
    }

    function handleOpenContact() {
        setCtcOpened(true);
    }

    function handleGarDec() {
        window.open('https://www.service-public.gouv.fr/particuliers/vosdroits/F2034', '_blank');
    }

    function Animated({children, ...props}) {
        return isMobile ? <div {...props}>{children}</div> : <Slide direction='up' /*triggerOnce cascade damping={0.03}*/ {...props}>{children}</Slide>
    }

    return <div className="flex app-footer" style={{overflow: 'hidden'}}>
        <Animated direction='up' className='flex allwidth padded5'>
           
            <div className="flex row allwidth">

                {/* C1: Menu */}
                <div className="flex allheight justifystart">
                    <div className='flex'>
                        <div className='white title'>Menu</div>
                        <div className='flex secondary'>
                            <div className='flex flexdot2 clickable hoverscale' onClick={() => gotoSection('accueil')}>Accueil</div>
                            <div className='flex flexdot2 clickable hoverscale' onClick={() => gotoSection('apropos')}>À Propos</div>
                            <div className='flex flexdot2 clickable hoverscale' onClick={() => gotoSection('projets')}>Mes Réalisations</div>
                        </div>
                    </div>

                    <br />
                    
                    <div className='flex'>
                        <div className='white title'>Information</div>
                        <div className='flex secondary'>
                            <div className='flex flexdot2 clickable hoverscale' onClick={handleGarDec}>Garantie Décennale</div>
                            <div className='flex flexdot2 clickable hoverscale' onClick={handleOpenLegalMentions}>Mentions Légales</div>
                            <div className='flex flexdot2 clickable hoverscale' onClick={handleOpenContact}>Contact</div>
                        </div>
                    </div>
                </div>

                {/* C2 */}
                <div className="flex allheight justifystart">
                    <div className='flex'>
                        {
                            isMobile
                            ? <div className="flex allheight justifystart">
                                <div className="flex clickable hoverscale" onClick={handleOpenFb}>
                                    <div className='white title xlarge'>Suivez-moi !</div>
                                    <div className='white marged-t'><FaFacebook size='5vh' /></div>
                                </div>
                            </div>
                            : null
                        }
                        <img src={logo} style={{ height: isMobile ? '15vh' : '25vh', width: 'auto', objectFit: 'contain' }} />
                        <p><i className='grey'>Pssst... les devis sont gratuits</i> 😉</p>
                    </div>
                </div>

                {/* C3 */}
                {
                    isMobile
                    ? null
                    : <div className="flex allheight justifystart">
                        <div className="flex clickable hoverscale" onClick={handleOpenFb}>
                            <div className='white title xxlarge'>Suivez-moi !</div>
                            <div className='white marged-t'><FaFacebook size='10vh' /></div>
                        </div>
                    </div>
                }

            </div>
        </Animated>

        <Layout 
            opened={lmOpened} 
            onClose={() => setLmOpened(false)}
        >
            <LegalMentions />
        </Layout>
        <Layout 
            opened={ctcOpened} 
            onClose={() => setCtcOpened(false)}
        >
            <div className='flex black justifystart'>
                <h1 className="txt-center text-shadow">Contact</h1>
                
                <div className='flex'>
                    <ul className='flexy alignstart'>
                        <li><b>Nom:</b> Pierre Darduin</li>
                        <li><b>Adresse:</b> 80200 Marchélepot</li>
                        <li><b>Email:</b> pierre.darduin@gmail.com</li>
                        <li><b>Téléphone:</b> 07 81 15 57 93</li>
                    </ul>
                </div>
            </div>
        </Layout>
    </div>
}